import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { AnalyticItem } from '@mgm/common/components';
import ScrollBar from '@mgm/common/components/ScrollBar';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getTimeOffs } from '../../../../store/schedules/selectors';

const TimeoffTotalsHeader = () => {
  const { t } = useTranslation('schedule');
  const theme = useTheme();
  const timeoffs = useAppSelector(getTimeOffs);

  const timeoffStatusTotals = useMemo(() => timeoffs.reduce(
    (acc, timeoff) => {
      if (timeoff.status === 'Approved') acc.approved += 1;
      else if (timeoff.status === 'Pending') acc.pending += 1;
      else if (timeoff.status === 'Declined') acc.declined += 1;
      acc.total += 1;
      return acc;
    },
    {
      approved: 0, pending: 0, declined: 0, total: 0,
    },
  ), [timeoffs]);

  return (
    <Card sx={{
      height: '88px',
    }}
    >
      <ScrollBar>
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />}
          sx={{ p: 2, overflow: 'auto !important' }}
        >
          <AnalyticItem
            id="total-requested"
            title={t('requested')}
            percent={100}
            price={timeoffStatusTotals.total}
            icon="mdi:file-document-add-outline"
            color={theme.palette.info.main}
          />
          <AnalyticItem
            id="total-approved"
            title={t('approved')}
            percent={100}
            price={timeoffStatusTotals.approved}
            icon="fluent:document-table-checkmark-24-regular"
            color={theme.palette.success.main}
          />
          <AnalyticItem
            id="total-rejected"
            title={t('rejected')}
            percent={100}
            price={timeoffStatusTotals.declined}
            icon="mdi:file-document-remove-outline"
            color={theme.palette.error.main}
          />
          <AnalyticItem
            id="total-pending"
            title={t('pending')}
            percent={100}
            price={timeoffStatusTotals.pending}
            icon="fluent:document-text-clock-24-regular"
            color="#F28C28"
          />
        </Stack>
      </ScrollBar>
    </Card>
  );
};

export { TimeoffTotalsHeader };
